import { Modal, Typography } from 'antd'
import Button from 'components/button/Button'
import { IconCancel } from 'components/icons'
import { DeliveryEnum, SaleOrderStatusEnum } from 'generated/api'

interface IProps {
  loading: boolean
  visibility: boolean
  orderStatus: SaleOrderStatusEnum | null
  deliveryMethod: DeliveryEnum | null
  onCancel: () => void
  onAccept: () => void
}

function ModalConfirmation(props: IProps) {
  const { onAccept, onCancel, visibility, loading } = props
  return (
    <Modal
      data-testid="modal_orders_status_confirmation"
      centered
      closable={!loading}
      onCancel={onCancel}
      open={visibility}
      footer={null}
      className="modal-orders-status-confirmation"
      closeIcon={<IconCancel strokeWidth="2" color="black" />}
    >
      <div className="flex flex-col mt-10">
        <Typography.Paragraph className="text-lg font-semibold leading-5 text-gray-700 mb-0">
          {props.orderStatus === SaleOrderStatusEnum.New
            ? 'Apakah Anda yakin ingin konfirmasi pesanan ini?'
            : null}
          {props.orderStatus === SaleOrderStatusEnum.Confirmed &&
          props.deliveryMethod === DeliveryEnum.Pickup
            ? 'Apakah Anda yakin pesanan sudah siap di ambil?'
            : null}
          {props.orderStatus === SaleOrderStatusEnum.Confirmed &&
          props.deliveryMethod === DeliveryEnum.Delivery
            ? 'Apakah Anda yakin pesanan dalam pengiriman?'
            : null}
          {props.orderStatus === SaleOrderStatusEnum.Delivering &&
          props.deliveryMethod === DeliveryEnum.Delivery
            ? 'Apakah Anda yakin pesanan telah selesai'
            : null}
        </Typography.Paragraph>
        {loading ? (
          <div data-testid="loader" className="flex items-center justify-center mt-4 text-center">
            <div className="loader" />
          </div>
        ) : (
          <div className="flex mt-4">
            <Button
              disabled={loading}
              block={true}
              onClick={onCancel}
              data-testid="btn_cancel"
              className="inline-block mr-4"
              label="BATALKAN"
            />
            <Button
              disabled={loading}
              block={true}
              onClick={onAccept}
              data-testid="btn_accept"
              className="inline-block"
              iconPosition="right"
              label="KONFIRMASI"
              variant="solid-primary"
            />
          </div>
        )}
      </div>
    </Modal>
  )
}

export default ModalConfirmation
